import React, { createContext, useContext, useEffect } from 'react'
import type { TenantBranding } from '@/lib/api'
import { applyDocumentBranding } from '@/lib/documentBranding'

const DEFAULT_BRANDING: TenantBranding = {
  name: null,
  primaryColor: '#3b82f6',
  logoUrl: null,
  tagline: null,
  welcomeMessage: null,
}

const BrandingContext = createContext<TenantBranding>(DEFAULT_BRANDING)

export function BrandingProvider({
  branding,
  children,
}: {
  branding: TenantBranding | null
  children: React.ReactNode
}) {
  // Every signed-in surface goes through this provider, so branding the
  // document here means no layout can forget to. A null branding (still
  // resolving, or a test) leaves the platform defaults alone rather than
  // clearing them.
  useEffect(() => {
    applyDocumentBranding(branding?.name, branding?.logoUrl, branding?.slug)
  }, [branding?.name, branding?.logoUrl, branding?.slug])

  return (
    <BrandingContext.Provider value={branding ?? DEFAULT_BRANDING}>
      {children}
    </BrandingContext.Provider>
  )
}

export function useBranding(): TenantBranding {
  return useContext(BrandingContext)
}
